(function () {
  'use strict';

  var R = window.Rappit || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var format = R.moneyFormat || '{{amount}}';
    var value = (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
      minimumFractionDigits: format.indexOf('no_decimals') > -1 ? 0 : 2,
      maximumFractionDigits: format.indexOf('no_decimals') > -1 ? 0 : 2
    });
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastEl = null;
  var toastTimer = null;

  function toast(message, tone) {
    toastEl = toastEl || document.getElementById('RappitToast');
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.className = 'toast is-visible' + (tone ? ' toast--' + tone : '');
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  function flash(button, message, ms) {
    if (button.dataset.flashing) return;
    button.dataset.flashing = '1';
    var original = button.innerHTML;
    button.innerHTML = message;
    button.classList.add('is-done');
    setTimeout(function () {
      button.innerHTML = original;
      button.classList.remove('is-done');
      delete button.dataset.flashing;
    }, ms || 1600);
  }

  function trapFocus(container, firstFocus) {
    var selector =
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(container.querySelectorAll(selector), function (el) {
        return el.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    (firstFocus || container).focus();

    return function release() {
      container.removeEventListener('keydown', onKeydown);
    };
  }

  var scrollLocks = 0;

  function lockScroll() {
    scrollLocks += 1;
    if (scrollLocks === 1) {
      document.body.style.overflow = 'hidden';
    }
  }

  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) {
      document.body.style.overflow = '';
    }
  }

  window.RappitUtils = { formatMoney: formatMoney, toast: toast, flash: flash };

  var Cart = {
    section: 'cart-drawer',

    request: function (url, body) {
      body.sections = this.section;
      body.sections_url = window.location.pathname;

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || R.strings.cartError);
          }
          return data;
        });
      });
    },

    render: function (data) {
      var markup = data.sections && data.sections[Cart.section];
      if (markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var incoming = parsed.querySelector('[data-cart-drawer-inner]');
        var current = document.querySelector('[data-cart-drawer-inner]');
        if (incoming && current) current.replaceWith(incoming);
      }

      var count = null;
      var root = document.querySelector('[data-cart-root]');
      if (root && root.dataset.cartCountValue !== undefined) count = parseInt(root.dataset.cartCountValue, 10);
      if ((count === null || isNaN(count)) && typeof data.item_count === 'number') count = data.item_count;

      if (count !== null && !isNaN(count)) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.classList.toggle('is-visible', count > 0);
        });
      }

      document.dispatchEvent(new CustomEvent('rappit:cart:updated', { detail: { count: count } }));
    },

    add: function (items) {
      return Cart.request(R.routes.cartAdd, { items: items }).then(function (data) {
        Cart.render(data);
        return data;
      });
    },

    change: function (payload) {
      return Cart.request(R.routes.cartChange, payload).then(function (data) {
        Cart.render(data);
        return data;
      });
    }
  };

  window.RappitCart = Cart;

  class RappitDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-drawer-panel]');
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.releaseFocus = null;
      this.opener = null;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]') || event.target === this.overlay) {
          this.close();
        }
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };
    }

    open(opener) {
      this.opener = opener || null;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      lockScroll();
      document.addEventListener('keydown', this.onKeydown);
      this.releaseFocus = trapFocus(this.panel, this.panel.querySelector('[data-drawer-close]'));
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      unlockScroll();
      document.removeEventListener('keydown', this.onKeydown);
      if (this.releaseFocus) this.releaseFocus();
      if (this.opener) this.opener.focus();
    }
  }
  customElements.define('rappit-drawer', RappitDrawer);

  function openDrawer(id, opener) {
    var drawer = document.getElementById(id);
    if (drawer && typeof drawer.open === 'function') drawer.open(opener);
    return drawer;
  }

  window.RappitDrawers = { open: openDrawer };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-drawer-open]');
    if (!trigger) return;
    var target = document.getElementById(trigger.dataset.drawerOpen);
    if (!target) return;
    event.preventDefault();
    target.open(trigger);
  });

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.querySelector('[type="submit"]');
      this.errorEl = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      if (this.dataset.cartType === 'page') return;
      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.setLoading(true);
      this.clearError();

      var formData = new FormData(this.form);
      var items = [
        {
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity') || '1', 10)
        }
      ];

      var props = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) props[match[1]] = value;
      });
      if (Object.keys(props).length) items[0].properties = props;

      var selling_plan = formData.get('selling_plan');
      if (selling_plan) items[0].selling_plan = selling_plan;

      Cart.add(items)
        .then(() => {
          if (R.cartType === 'drawer') {
            openDrawer('CartDrawer', this.button);
          } else {
            window.location.href = R.routes.cart;
          }
        })
        .catch((error) => this.showError(error.message))
        .finally(() => this.setLoading(false));
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      if (this.button) this.button.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    clearError() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    showError(message) {
      if (this.errorEl) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      } else {
        toast(message, 'error');
      }
    }
  }
  customElements.define('product-form', ProductForm);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();

    var id = button.dataset.quickAdd;
    if (!id) return;

    button.setAttribute('aria-busy', 'true');
    Cart.add([{ id: id, quantity: 1 }])
      .then(function () {
        flash(button, R.strings.addedToCart);
      })
      .catch(function (error) {
        toast(error.message, 'error');
      })
      .finally(function () {
        button.setAttribute('aria-busy', 'false');
      });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-line-change]');
    if (!button) return;
    event.preventDefault();

    var line = parseInt(button.dataset.line, 10);
    var quantity = parseInt(button.dataset.lineChange, 10);
    var root = button.closest('[data-cart-root]');
    if (root) root.classList.add('is-busy');

    Cart.change({ line: line, quantity: quantity })
      .catch(function (error) {
        toast(error.message, 'error');
      })
      .finally(function () {
        var next = document.querySelector('[data-cart-root]');
        if (next) next.classList.remove('is-busy');
      });
  });

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          var step = button.name === 'plus' ? 1 : -1;
          var min = parseInt(this.input.min || '1', 10);
          var max = this.input.max ? parseInt(this.input.max, 10) : Infinity;
          var next = Math.min(max, Math.max(min, (parseInt(this.input.value, 10) || min) + step));
          this.input.value = next;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }
  customElements.define('quantity-input', QuantityInput);

  class RailCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.rail) return;

      this.rtl = document.documentElement.dir === 'rtl';
      this.boundUpdate = this.updateButtons.bind(this);

      if (this.prev) this.prev.addEventListener('click', () => this.page(-1));
      if (this.next) this.next.addEventListener('click', () => this.page(1));

      this.rail.addEventListener('scroll', this.boundUpdate, { passive: true });
      window.addEventListener('resize', this.boundUpdate, { passive: true });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.boundUpdate);
        this.observer.observe(this.rail);
        var firstCard = this.rail.firstElementChild;
        if (firstCard) this.observer.observe(firstCard);
      }
      window.addEventListener('load', this.boundUpdate, { once: true });

      this.updateButtons();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.boundUpdate);
      cancelAnimationFrame(this.frame);
    }

    get step() {
      var card = this.rail.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(this.rail).columnGap || '16') || 16;
      return card ? (card.offsetWidth + gap) * 2 : this.rail.clientWidth;
    }

    page(direction) {
      var delta = (this.rtl ? -direction : direction) * this.step;
      var max = this.rail.scrollWidth - this.rail.clientWidth;
      var target = Math.max(0, Math.min(max, Math.abs(this.rail.scrollLeft) + delta));
      this.animateTo(this.rtl ? -target : target);
    }

    animateTo(target) {
      var rail = this.rail;
      var start = rail.scrollLeft;
      var distance = target - start;

      cancelAnimationFrame(this.frame);

      if (reduceMotion || Math.abs(distance) < 2) {
        rail.scrollLeft = target;
        this.updateButtons();
        return;
      }

      var snap = rail.style.scrollSnapType;
      rail.style.scrollSnapType = 'none';

      var duration = 420;
      var startedAt = null;
      var easeOut = function (t) {
        return 1 - Math.pow(1 - t, 3);
      };

      var tick = (now) => {
        if (startedAt === null) startedAt = now;
        var progress = Math.min(1, (now - startedAt) / duration);
        rail.scrollLeft = start + distance * easeOut(progress);

        if (progress < 1) {
          this.frame = requestAnimationFrame(tick);
        } else {
          rail.style.scrollSnapType = snap;
          this.updateButtons();
        }
      };

      this.frame = requestAnimationFrame(tick);
    }

    updateButtons() {
      if (!this.prev || !this.next) return;
      var max = this.rail.scrollWidth - this.rail.clientWidth - 2;
      var pos = Math.abs(this.rail.scrollLeft);
      this.prev.disabled = pos <= 2;
      this.next.disabled = pos >= max;
    }
  }
  customElements.define('rail-carousel', RailCarousel);

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-announcement]'));
      if (this.items.length < 2) return;

      var interval = parseInt(this.dataset.interval, 10) || 4200;
      var index = 0;

      this.timer = setInterval(() => {
        if (document.hidden) return;
        this.items[index].classList.remove('is-active');
        index = (index + 1) % this.items.length;
        this.items[index].classList.add('is-active');
      }, interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }
  customElements.define('announcement-rotator', AnnouncementRotator);

  class StickyBar extends HTMLElement {
    connectedCallback() {
      var watchId = this.dataset.watch;
      var watched = watchId ? document.getElementById(watchId) : null;
      if (!watched || !('IntersectionObserver' in window)) return;

      new IntersectionObserver(
        (entries) => {
          var entry = entries[0];
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(watched);
    }
  }
  customElements.define('sticky-bar', StickyBar);

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    var observeReveals = function (root) {
      (root || document).querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
        revealObserver.observe(el);
      });
    };

    document.addEventListener('DOMContentLoaded', function () {
      observeReveals();
    });
    document.addEventListener('shopify:section:load', function (event) {
      observeReveals(event.target);
    });
    observeReveals();
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  (function heroVideo() {
    var videos = document.querySelectorAll('[data-hero-video]');
    if (!videos.length) return;

    var wantsMobile = window.matchMedia('(max-width: 749px)').matches;
    var wanted = wantsMobile ? 'mobile' : 'desktop';

    videos.forEach(function (video) {
      if (video.dataset.heroVideo !== wanted) {
        video.remove();
        return;
      }

      var wrap = video.closest('.hero__media');
      if (!wrap) return;

      if (reduceMotion) {
        video.remove();
        return;
      }

      var revealed = false;
      var reveal = function () {
        if (revealed) return;
        revealed = true;
        wrap.classList.add('is-playing');
      };

      ['loadeddata', 'canplay', 'playing'].forEach(function (event) {
        video.addEventListener(event, reveal, { once: true });
      });
      if (video.readyState >= 2) reveal();
      setTimeout(function () {
        if (video.readyState >= 2) reveal();
      }, 2500);

      video.preload = 'auto';
      video.muted = true;
      video.load();

      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {

          wrap.classList.remove('is-playing');
        });
      }
    });
  })();

  (function footerAccordion() {
    var footer = document.querySelector('[data-footer-collapsible]');
    if (!footer) return;

    var groups = footer.querySelectorAll('[data-footer-group]');
    if (!groups.length) return;

    var phone = window.matchMedia('(max-width: 749px)');

    var apply = function () {
      groups.forEach(function (group) {

        if (phone.matches) {
          if (!group.dataset.touched) group.open = false;
        } else {
          group.open = true;
        }
      });
    };

    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (phone.matches) group.dataset.touched = '1';
      });
    });

    apply();
    if (phone.addEventListener) {
      phone.addEventListener('change', function () {
        groups.forEach(function (g) {
          delete g.dataset.touched;
        });
        apply();
      });
    }
  })();

  (function headerShadow() {
    var header = document.querySelector('.header--sticky');
    if (!header || !('IntersectionObserver' in window)) return;

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  })();

  document.addEventListener('shopify:section:select', function (event) {
    var drawer = event.target.querySelector('rappit-drawer');
    if (drawer) drawer.open();
  });
})();
